import { AuthUser, getCurrentUser } from "aws-amplify/auth";
import Snackbar from "@mui/material/Snackbar";
import { useEffect, useState } from "react";
import { AppBar, Button, Toolbar } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";

const PortalWrapper: React.FC = () => {
    const [user, setUser] = useState<AuthUser | undefined>(undefined);
    const [hide, setHide] = useState(false);
    const location = useLocation();
    const [isPortal, setIsPortal] = useState(location.hash.startsWith(`#/portal`));

    useEffect(() => {
        setIsPortal(location.hash.startsWith(`#/portal`));
        try {
            getCurrentUser()
                .then((currentUser) => setUser(currentUser))
                .catch(() => setUser(undefined));
        } catch {
            setUser(undefined);
        }
    }, [location]);

    // Track login status of user to notify them of their current login status.
    useEffect(() => {
        getCurrentUser()
            .then((currentUser) => setUser(currentUser))
            .catch(() => setUser(undefined));
    }, []);

    if (!isPortal || !user) return <Outlet />;

    return (
        <>
            <Outlet />
            <Snackbar
                open={!!user && !hide}
                autoHideDuration={6000}
                message={
                    user?.signInDetails?.loginId
                        ? `Currently authenticated as ${user?.signInDetails?.loginId}`
                        : `Current authenticated with customer portal`
                }
                onClose={() => setHide(true)}
            />
            <AppBar
                position="relative"
                variant="outlined"
                sx={{ top: "auto", bottom: 0, backgroundColor: "white", zIndex: 10 }}
            >
                <Toolbar variant="dense">
                    <Button
                        onClick={() => {
                            (window as any).SpiffThemeLoader.close();
                        }}
                        variant="outlined"
                        color="primary"
                        sx={{ marginLeft: "auto", textTransform: "none" }}
                    >
                        Return to Customer Portal
                    </Button>
                </Toolbar>
            </AppBar>
        </>
    );
};

export default PortalWrapper;
